import { Injectable } from '@angular/core';
import { MdDialog, MdDialogRef } from '@angular/material';
import { InfoDialogComponent, InfoDialogOptions, InfoDialogType } from '../components/info-dialog/info-dialog.component';

@Injectable()
export class InfoDialogService {
	constructor(private dialog: MdDialog) { }

	alert(title: string, message: string, callback?: () => void, primaryButton?: string, secondaryButton?: string) {
		let data: InfoDialogOptions = {
			dialogType: InfoDialogType.Alert,
			message: message,
			title: title,
			primaryButton: primaryButton,
			secondaryButton: secondaryButton
		}
		let d = this.dialog.open(InfoDialogComponent, {
			width: 'auto',
			data: data
		});
		if (callback)
			d.afterClosed().subscribe(x => {
				if (callback)
					callback();
			});
	}
	prompt(title: string, message: string, callback: (result: string) => void, defaultText?: string, primaryButton?: string, secondaryButton?: string) {
		let data: InfoDialogOptions = {
			dialogType: InfoDialogType.Prompt,
			message: message,
			title: title,
			defaultInputText: defaultText,
			primaryButton: primaryButton,
			secondaryButton: secondaryButton
		}

		let d = this.dialog.open(InfoDialogComponent, {
			width: 'auto',
			data: data
		});
		d.afterClosed().subscribe(x => {
			callback(x as string);
		});
	}
	confirm(title: string, message: string, callback: (result: boolean) => void, primaryButton?: string, secondaryButton?: string) {
		let data: InfoDialogOptions = {
			dialogType: InfoDialogType.Confirm,
			message: message,
			title: title,
			primaryButton: primaryButton,
			secondaryButton: secondaryButton
		}

		let d = this.dialog.open(InfoDialogComponent, {
			width: 'auto',
			data: data
		});
		d.afterClosed().subscribe(x => {
			callback(x as boolean);
		});
	}
}



// WEBPACK FOOTER //
// D:/NOWFLOATS/ana-web-chat-master-f726fd66c7ed228fb0b4a1e0e71ea760bd266a85/src/app/services/info-dialog.service.ts